export default __webpack_public_path__ + "static/media/cross.3e4720a9.png";